import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col } from "reactstrap"

import { Link } from "react-router-dom"

// components
import Applications from "pages/Dashboard/applications"

// services
import ApplicationService from "../../services/applications/Application.service"
import Staff from "services/staff/Staff"
import ApplicationFilter from "components/Filter/ApplicationFilter"

let appService = null
let plasticsUser = null
let staffService = new Staff()

const Rejected = () => {
  const [menu, setMenu] = useState(false)
  const [user, setuser] = useState()
  const [mounted, setmounted] = useState(false)
  const [rejected, setrejected] = useState()
  const [searchMode, setsearchMode] = useState(false)
  const [filterValues, setFilterValues] = useState({
    search: "",
    application_status: "",
    date_from: "",
    date_to: "",
  })

  const toggle = () => {
    setMenu(!menu)
  }

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    appService = new ApplicationService(userObj)

    setuser(userObj)
    plasticsUser = appService.getStrategy("head")
    plasticsUser.getRejectedApplications(1).then(response => {
      if (response.status) {
        setrejected(response.data)
        setmounted(true)
      }
    })
  }, [])

  const paginate = page => {
     // If we are in search mode, we will call the search endpoint instead
     if (searchMode) {
      appService.searchApplications(filterValues, page).then(response => {
        setrejected(response.data)
      })
    } else {
      plasticsUser.getRejectedApplications(page).then(response => {
        if (response.status) {
          setrejected(response.data)
        }
      })
    }
    
  }

  const initiateSearch = (data) => {
    data = {...data, application_status: "REJECTED"}
    setsearchMode(true)
    setFilterValues(data)
    appService.searchApplications(data, null).then(response => {
      if (response?.code && response.code == 200) {
        if (response.data.total == 0) {
          setrejected({data: []})
        } else {
          setrejected(response.data)
        }
      } else {
        setrejected({data: []})
      }
    })
  }

  const turnOffSearchMode = () => {
    setsearchMode(false)
    paginate(0)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Rejected | HoD</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Rejected</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    All rejected applications will show up here.
                  </li>
                </ol>
              </Col>
            </Row>
          </div>

          {mounted ? (
            <Row>
              <ApplicationFilter allApplications={false} handleSearch={initiateSearch} turnOffSearch={turnOffSearchMode} />

              <Applications
                viewOnly={true}
                user={user}
                data={rejected}
                paginate={paginate}
              />
            </Row>
          ) : null}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Rejected
